import { css } from '@flipster/styled-system/css';

interface Props {
  trendUp: number;
  neutral: number;
  trendDown: number;
  total: number;
}

export const TrendBar = ({ trendUp, neutral, trendDown, total }: Props) => {
  const moreThanOrEqualTrendUp = trendUp >= trendDown && trendUp > 0;
  const moreThanOrEqualTrendDown = trendDown >= trendUp && trendDown > 0;
  const moreThanOrEqual3PercentNeutral = neutral / total >= 0.03;

  return (
    <div
      className={css({
        display: 'flex',
        gap: 1,
        width: '100%',
        height: { base: 6, tablet: 8 },
        backgroundColor: 'background.default.level-3',
        borderRadius: 8,
        '& > div': {
          height: '100%',
          borderRadius: '8px',
        },
      })}
    >
      <div
        className={css(
          { tablet: { backgroundColor: 'content.state.positive' } },
          moreThanOrEqualTrendUp && { backgroundColor: 'content.state.positive' },
        )}
        style={{ width: `${(trendUp / total) * 100}%` }}
      />
      <div
        className={css(moreThanOrEqual3PercentNeutral && { backgroundColor: 'content.default.level-3' })}
        style={{ width: `${(neutral / total) * 100}%` }}
      />
      <div
        className={css(
          { tablet: { backgroundColor: 'content.state.negative' } },
          moreThanOrEqualTrendDown && { backgroundColor: 'content.state.negative' },
        )}
        style={{ width: `${(trendDown / total) * 100}%` }}
      />
    </div>
  );
};
